import * as React from 'react';
import classNames from 'classnames';
import styles from './size-value.scss';
import f_styles from '../filterValue/filter-value.scss';
import { IFilterValueProps } from '../filterValue/filter-value.d';
import TabNavigationHelper from '../../../Common/tabNavigationHelper';
import * as helper from '../../../Common/html-helper';

export interface ISizeFilterProps extends IFilterValueProps {
    isSpecialLayout: boolean;
}

export default class SizeValue extends React.Component<ISizeFilterProps> {
    private tabNav: TabNavigationHelper;

    constructor(props) {
        super(props);
        this.state = {};
        this.tabNav = TabNavigationHelper.instance;
        this.onValueClicked = this.onValueClicked.bind(this);
    }

    public render() {
        const isDisabled = this.props.filterPropertyValue.articlesAmount === 0;

        return (
            <div className={classNames(styles.size_value,
                f_styles.filter_value,
                { [f_styles.selected_value]: this.props.isSelected },
                { [styles.special_layout]: this.props.isSpecialLayout },
                { [styles.disabled_value]: isDisabled })}
                data-testid='size_value' data-semantic-id='size_value'
                ref={(el)=> {
                    if(!isDisabled)
                        this.tabNav.setFocusAtt(el);
                }}
                onClick={this.onValueClicked}
                onKeyDown={this.tabNav.handleKeyDown}>
                <div className={styles.size_title} 
                    ref={(el)=> helper.avoidGoogleTranslate(el)}>
                    {this.props.filterPropertyValue.title}
                </div>
            </div>
        );
    }

    private onValueClicked() {
        if (this.props.isSelected)
            this.props.removeSelectedFilter(this.props.filter);
        else
            this.props.addSelectedFilter(this.props.dimension, this.props.filterPropertyValue);
    }
}

